import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class GrooveRecommendationService {
    private grooveRecommendation;
    private OringRecommendationJis;
    constructor(private http: HttpClient) {}

    private getGrooveRecommendationData() {
      this.grooveRecommendation = this.http.get('assets/calculations-json/Groove recommendation.json');
    }

  private OringRecommendationJisData() {
    this.OringRecommendationJis = this.http.get('assets/calculations-json/Groove recommendation_jis.json');
  }

    getGrooveRecommendation() {
      if (!this.grooveRecommendation) {
        this.getGrooveRecommendationData();
      }
      return this.grooveRecommendation;
    }

  getOringRecommendationJis() {
    if (!this.OringRecommendationJis) {
      this.OringRecommendationJisData();
    }
    return this.OringRecommendationJis;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/service/GrooveRecommendationService.ts